import * as React from 'react';

// PACKAGES
import { Formik, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

// COMPONENTS
import SingleSelect from '../../../components/SingleSelect';
import Button from '../../../components/Button';

// TYPES
import { CertificationTypes } from './CertificationStaff';
import { OrganisationFindLookupEntry } from '../../../api/models';

interface PartOneTypes {
	certificationData: CertificationTypes;
	setFormSection: React.Dispatch<React.SetStateAction<string>>;
	setCertificationFormData: React.Dispatch<React.SetStateAction<CertificationTypes>>;
	staffTypes?: Array<OrganisationFindLookupEntry>;
}

const PartOne: React.FC<PartOneTypes> = ({
	certificationData,
	setFormSection,
	setCertificationFormData,
	staffTypes
}) => {
	// Submit part one form data to AddCertification
	const continueFormStepOne = (values: any) => {
		setFormSection('2');
		setCertificationFormData((prevState) => ({
			...prevState,
			organisationRole: values.organisationRole
		}));
	};

	// Validation
	const formValidationSchema = Yup.object().shape({
		organisationRole: Yup.string().required('Required')
	});

	// Set initial form values
	const initialFormValuesPartOne = {
		organisationRole: certificationData ? certificationData.organisationRole : ''
	};

	return (
		<Formik
			initialValues={initialFormValuesPartOne}
			onSubmit={continueFormStepOne}
			enableReinitialize={true}
			validationSchema={formValidationSchema}
		>
			{(formik) => {
				return (
					<Form translate="yes">
						<div className="form-group">
							<label htmlFor="organisationRole" className="label">
								1. Please confirm your role at this organisation
							</label>

							<SingleSelect
								onChange={(e: string) => formik.setFieldValue('organisationRole', e)}
								options={staffTypes}
								name="organisationRole"
								value={formik.values.organisationRole}
							/>

							<ErrorMessage name={`organisationRole`}>
								{(error) => <div className="form-validation-error">{error}</div>}
							</ErrorMessage>
						</div>

						<Button type="submit" className="btn btn-primary full-width">
							Continue
						</Button>
					</Form>
				);
			}}
		</Formik>
	);
};

export default PartOne;
